function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $5373aada3bcbc6ae$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"hbTCY":"shopping-list.09bbef4f.js","gZUBb":"amazon-logo.1ffb51bc.png","8hF3U":"applebooks-logo.4be09ee7.png","bILka":"bookshop3xOpt.d175b984.png","a8uN9":"thispageisempty2xOpt.d40f7c73.png","5e8AR":"shopping-list.f25d4547.css","bK9uH":"shopping-list.c328412f.js","kFkxa":"shopping-list.f8af9a2e.js"}'));


//# sourceMappingURL=shopping-list.4e86fcad.js.map
